import PermissionsGate from "../../../../api/PermissionsGate"
import { SCOPES } from "../../../../config/permissions-map"
import { Unauthorized } from "../../../Global/unauthorized"

import { GenerationCartasNotariales, GetCartasFianzaByVencer, GetCartasNotarales, GetConfigurationGenerationCartaNotarial, SaveConfigurationGenerationCartaNotarial, SaveEntregaCartaRequerimiento } from "../../../../api/Api"
import './ListadoCartaFianza.css'

import moment from 'moment'
import { useCallback, useMemo, useRef, useState } from "react"
import { PageTitle } from "../../../../../_metronic/layout/core"

import { useQuery, useQueryClient } from "react-query"
import WrappedAgTable from "../../../../Components/Table/WrappedAgTable"
import ConfigurationGenerationCartaNotarialModal from "./components/ConfigurationGenerationCartaNotarialModal"
import ConfirmWithLoader from "../../../../Components/Modals/ConfirmWithLoader"
import { useGetUser } from "../../../../Hooks/CustomHooks"
import Tippy from "@tippyjs/react"
import EntregaCartaModal from "../Components/EntregaCartaModal"
import { createCustomDateFilterParams } from "../../../../Components/Utils/Utils"
import CardEx from "../../../../Components/Cards/CardEx"
import cogoToast from "cogo-toast"


export default function ListadoGarantiasRequerimiento({ title }) {

    const { data: cartasFianzaByVencerRes, refetch: refetchGetCartasFianzaByVencer } = useQuery('getCartasFianzaByVencer', GetCartasFianzaByVencer);
    const { data: cartasNotarialesRes, refetch: refetchGetCartasNotarales } = useQuery('getCartasNotarales', GetCartasNotarales);
    const {
        data: configurationGenerationCnRes,
        refetch: refetchConfigurationGenerationCn } = useQuery('getConfigurationGenerationCartaNotarial',
            GetConfigurationGenerationCartaNotarial, {
            enabled: false,
        });

    const queryClient = useQueryClient();

    const [selectedRowsByGroupCartasFianza, setSelectedRowsByGroupCartasFianza] = useState([]);
    const [showConfigurationGenerationModal, setShowConfigurationGenerationModal] = useState(false);
    const [isFinishConfigurationSave, setIsFinishConfigurationSave] = useState(false);
    const [configurationSaveErrorMessage, setConfigurationSaveErrorMessage] = useState("");

    const [showGenerationCartaModal, setShowGenerationCartaModal] = useState(false);
    const [isLoandingGenerationCarta, setIsLoandingGenerationCarta] = useState(false);
    const [isFinishGenerationCarta, setIsFinishGenerationCarta] = useState(false);
    const [cartasNotarialesGeneratedRes, setCartasNotarialesGeneratedRes] = useState([]);

    const [showEntregaCartaModal, setShowEntregaCartaModal] = useState(false);
    const [isFinishEntregaCartaSave, setIsFinishEntregaCartaSave] = useState(false);
    const [valueEntregaCarta, setValueEntregaCarta] = useState(null);
    const [entregaCartaSaveErrorMsg, setEntregaCartaSaveErrorMsg] = useState(null);
    const idCartaRequerimiento = useRef(null);
    const user = useGetUser();

    const autoGroupColumnCartaFianza = useMemo(() => {
        return {
            headerName: 'Grupo',
            minWidth: 150,
            cellRenderer: "agGroupCellRenderer",
            cellRendererParams: {
                checkbox: true
            },
            headerCheckboxSelection: true,
            headerCheckboxSelectionCurrentPageOnly: true,
            filter: 'agGroupColumnFilter',

        };
    }, []);

    const autoGroupColumnCartasNotarialesGenerated = useMemo(() => {
        return {
            headerName: 'Nro Carta',
            field: 'nro_carta',
            minWidth: 150,
            filter: 'agTextColumnFilter'
        };
    }, []);

    const headerCartasFianza = useMemo(() => [
        {
            headerName: 'Banco',
            field: 'codigo_banco',
            rowGroup: true,
            hide: true,
        },
        {
            headerName: 'RUC',
            field: 'ruc',
            filter: 'agTextColumnFilter',

        },
        {
            headerName: 'Razon Social',
            field: 'razon_social',
            filter: 'agTextColumnFilter',
            flex: 1,
            minWidth: 260
        },
        {
            headerName: 'Nro Carta Fianza',
            field: 'nro_carta_fianza',
            filter: 'agTextColumnFilter'
        },
        {
            headerName: 'Fecha Expiración',
            field: 'fecha_vencimiento_carta_fianza',
            filter: 'agDateColumnFilter',
            filterParams: createCustomDateFilterParams,
            valueFormatter: (params) => {
                return params.value && moment(params.value).format("DD/MM/yyyy");
            }
        },
    ], []);

    const handleShowEntregaCartaModal = useCallback((event) => {
        setShowEntregaCartaModal(true);
        idCartaRequerimiento.current = event.id_carta;
        setValueEntregaCarta({
            fechaLimite: event.fecha_entrega,
            estado: {
                value: event.codigo_estado_entrega,
                label: event.nombre_estado_entrega
            }
        })

    }, []);

    const headerCartasNotariales = useMemo(() => [
        {
            headerName: 'Acciones',
            width: 100,
            filter: false,
            pinned: 'left',
            sortable: false,
            cellRenderer: (props) => props.data ? (
                <div className="d-flex align-items-center h-100 justify-content-center">
                    <Tippy theme='light-border' content="Descargar">
                        <a href={props.data.url} target="_blank" className="garantias-font align-items-center d-flex h-100 justify-content-center" rel="noreferrer">
                            <i className="fi fi-rr-download"></i>
                        </a>
                    </Tippy>
                    <Tippy theme='light-border' content="Registrar Retorno de Carta">
                        <button className="btn btn-link garantias-font align-items-center d-flex h-100 justify-content-center mx-auto"
                            onClick={() => handleShowEntregaCartaModal(props.data)}>
                            <i className="fi fi-rr-file-edit"></i>
                        </button>
                    </Tippy>

                </div>
            ) : <></>
        },
        {
            headerName: 'Nro Carta Notarial',
            field: 'nro_carta',
            filter: 'agTextColumnFilter',
            width: 200,
        },
        {
            headerName: 'Banco',
            field: 'codigo_banco',
            flex: 1
        },
        {
            headerName: 'Fecha Generación',
            field: 'fecha_generacion',
            filter: 'agDateColumnFilter',
            width: 180,
            filterParams: createCustomDateFilterParams,
            valueFormatter: (params) => {
                return params.value && moment(params.value).format("DD/MM/yyyy");
            }
        },
        {
            headerName: 'Fecha Entrega',
            field: 'fecha_entrega',
            filter: 'agDateColumnFilter',
            filterParams: createCustomDateFilterParams,
            valueFormatter: function (params) {
                return (params.value) ? `${moment(params.value).format("DD/MM/yyyy")}` : null;
            },
            width: 180
        },
        {
            headerName: 'Estado',
            field: 'nombre_estado_entrega',
            width: 150
        }
    ], [handleShowEntregaCartaModal]);

    const headerCartasNotarialesGenerated = useMemo(() => [
        {
            headerName: 'Banco',
            field: 'codigo_banco',
            rowGroup: true,
            hide: true
        },
        {
            headerName: 'Descargar',
            cellRenderer: (props) => (
                props.data && props.data.url ? (
                    <a href={props.data.url} target="_blank" className="garantias-font align-items-center d-flex h-100 justify-content-center" rel="noreferrer">
                        <i className="fi fi-rr-download"></i>
                    </a>
                ) : null
            )
        }
    ], []);

    const handleSelectionCartasFianza = useCallback((event) => {
        const selectedRows = event.api.getSelectedRows();
        let output = [];
        let groupByBanco = {};

        selectedRows.forEach(rowData => {
            const idBanco = rowData.id_banco;
            if (!groupByBanco[idBanco]) {
                groupByBanco[idBanco] = [];
            }
            groupByBanco[idBanco].push(rowData.id_garantia_detalle);
        });

        Object.keys(groupByBanco).forEach(idBanco => {
            const idGarantiasList = groupByBanco[idBanco];
            output.push({
                id_banco: idBanco,
                garantias: idGarantiasList,
                updated_by: user.email
            });
        });

        setSelectedRowsByGroupCartasFianza(output);
    }, [user.email]);


    const agGridCartasFianzas = useMemo(() => ({
        columnDefs: headerCartasFianza,
        rowData: cartasFianzaByVencerRes?.data,
        autoGroupColumnDef: autoGroupColumnCartaFianza,
        rowSelection: 'multiple',
        groupSelectsChildren: true,
        groupSelectsFiltered: true,
        pagination: false,
        onSelectionChanged: handleSelectionCartasFianza,
        rowGroupPanelShow: 'always',
        groupDisplayType: 'singleColumn',
        domLayout: "normal",
        suppressRowClickSelection: true,
        defaultColDef: {
            sortable: true,
            filter: true,
            resizable: true,
            minWidth: 90,
            floatingFilter: true,
            enableRowGroup: true
        },
    }), [cartasFianzaByVencerRes?.data, handleSelectionCartasFianza, headerCartasFianza, autoGroupColumnCartaFianza]);

    const agGridCartasNotariales = useMemo(() => ({
        columnDefs: headerCartasNotariales,
        rowData: cartasNotarialesRes?.data,
        pagination: true,
        rowGroupPanelShow: 'always',
        groupDisplayType: 'singleColumn',
        domLayout: "normal",
        defaultColDef: {
            sortable: true,
            filter: true,
            resizable: true,
            minWidth: 90,
            floatingFilter: true,
            enableRowGroup: true
        },
    }), [cartasNotarialesRes?.data, headerCartasNotariales]);

    const agGridCartasNotarialesGenerated = useMemo(() => ({
        columnDefs: headerCartasNotarialesGenerated,
        rowData: cartasNotarialesGeneratedRes,
        autoGroupColumnDef: autoGroupColumnCartasNotarialesGenerated,
        pagination: false
    }), [autoGroupColumnCartasNotarialesGenerated, cartasNotarialesGeneratedRes, headerCartasNotarialesGenerated]);

    const handleShowConfigurationGenerationModal = useCallback(() => {
        setShowConfigurationGenerationModal(true);
        refetchConfigurationGenerationCn();
    }, [refetchConfigurationGenerationCn]);

    const handleConfirmConfiguration = useCallback((event) => {
        queryClient.fetchQuery('saveConfigurationGenerationCartaNotarial',
            () => SaveConfigurationGenerationCartaNotarial(event)).then((result) => {
                if (result.data.success) {
                    setConfigurationSaveErrorMessage("");
                } else {
                    setConfigurationSaveErrorMessage("ERRORRR....");
                }
                setIsFinishConfigurationSave(true);
            }).catch((err) => {
                setConfigurationSaveErrorMessage("ERRORRR....");
                setIsFinishConfigurationSave(true);
            });
    }, [queryClient]);

    const handleCloseConfiguration = useCallback(() => {
        setConfigurationSaveErrorMessage("");
        queryClient.setQueryData('getConfigurationGenerationCartaNotarial', null);
    }, [queryClient])


    const handleShowGenerationModal = useCallback(() => {
        setShowGenerationCartaModal(true);
    }, []);

    const handleConfirmGeneration = useCallback(async () => {
        setIsLoandingGenerationCarta(true);

        let queryList = [];
        let queryResults = null;
        let cartasNotarialesList = [];

        selectedRowsByGroupCartasFianza.forEach(item => {
            const query = queryClient.fetchQuery(`generationCartasNotariales-${item.id_banco}`, () => GenerationCartasNotariales(item));
            queryList.push(query);
        });

        queryResults = await Promise.all(queryList);

        queryResults.forEach((result, index) => {
            const queryKey = queryList[index].queryKey;

            if (result.status === 200) {
                if (result.data.success) {
                    cartasNotarialesList.push(...result.data.data);
                } else {
                    // Error que devuelve el servicio como mensaje
                    console.log("ERROR SERVICIO");
                    console.log(queryKey);
                    console.log(result.data.message);
                }
            } else {
                //Error HTTP
                console.log("ERROR HTTP");
                console.log(queryKey);
                console.log(result.error);
            }
        });
        setCartasNotarialesGeneratedRes(cartasNotarialesList);
        refetchGetCartasFianzaByVencer();
        refetchGetCartasNotarales();
        setIsLoandingGenerationCarta(false);
        setIsFinishGenerationCarta(true);
        setSelectedRowsByGroupCartasFianza([]);
    }, [queryClient, refetchGetCartasFianzaByVencer, refetchGetCartasNotarales, selectedRowsByGroupCartasFianza])

    const handleCloseGeneration = useCallback(() => {
        setCartasNotarialesGeneratedRes([]);
        setIsLoandingGenerationCarta(false);
        setIsFinishGenerationCarta(false);
    }, [])


    const handleConfirmEntregaCarta = useCallback((event) => {
        setIsFinishEntregaCartaSave(false);
        const obj = {
            "id_carta_requerimiento": idCartaRequerimiento.current,
            "fecha_entrega": moment(event.fechaLimite).toISOString(),
            "codigo_estado_entrega": event.estado.value,
            "updated_by": user.email
        }
        queryClient.fetchQuery('saveEntregaCartaRequerimiento',
            () => SaveEntregaCartaRequerimiento(obj)).then((result) => {
                if (result.status === 200) {
                    if (result.data.success) {
                        refetchGetCartasNotarales();
                        setEntregaCartaSaveErrorMsg(null);
                    } else {
                        setEntregaCartaSaveErrorMsg("ERRORRR....");
                    }
                } else {
                    setEntregaCartaSaveErrorMsg("ERRORRR....");
                }
            }).catch((err) => {
                setEntregaCartaSaveErrorMsg("ERRORRR....");
            }).finally(() => {
                setIsFinishEntregaCartaSave(true);
            });
    }, [queryClient, refetchGetCartasNotarales, user.email]);

    const handleCloseEntregaCarta = useCallback(() => {
        setIsFinishEntregaCartaSave(false);
        setEntregaCartaSaveErrorMsg(null);
        setValueEntregaCarta(null);
        idCartaRequerimiento.current = null;
    }, []);

    const breadcrumbs = [
        { title: "Inicio", path: "/dashboard", isActive: true, isSeparator: false },
        { title: "", path: "", isActive: false, isSeparator: true },
        { title: "Garantías", path: "", isActive: false, isSeparator: false },
    ];

    return (
        <>
            <PermissionsGate RenderError={() => <Unauthorized />} scopes={[SCOPES.GARANTIAS_REQUERIMIENTO_CARTA_FIANZA]} >
                <PageTitle breadcrumbs={breadcrumbs}>{title}</PageTitle>
                <CardEx titleParent={title} 
                    title={"Listado de Garantías por vencer"} 
                    isAvailableMaximized={true}
                    isAvailableBreadcrumbs={true}
                    isAvailableRefetch={true}
                    breadcrumbs={breadcrumbs} 
                    height={"700px"} 
                    onRefetch={async () => {
                    await refetchGetCartasFianzaByVencer();
                    cogoToast.success('Registros actualizado satisfactoriamente!', {
                        //hideAfter: 0,
                        heading: 'Listado de Garantías por vencer',
                        position: 'top-right'
                    });
                }}>
                    <WrappedAgTable
                        {...agGridCartasFianzas} >
                        <button className="btn btn-sm btn-primary ms-2"
                            disabled={selectedRowsByGroupCartasFianza.length === 0}
                            onClick={handleShowGenerationModal}>
                            <span className="fw-bold ">
                                <i className="fs-5 fi-rr-add-document fw-bold"></i> Generar
                            </span>
                        </button>
                        <button className="btn bg-light-blue btn-sm ms-2" onClick={handleShowConfigurationGenerationModal}>
                            <span className="text-blue fw-bold ">
                                <i className="fs-6 fi-rr-settings text-blue fw-bold pe-0"></i>
                            </span>
                        </button>
                    </WrappedAgTable>
                </CardEx>
                <div className="separator-h"></div>
                <CardEx titleParent={title} 
                    title={"Listado de Cartas Notariales"} 
                    isAvailableMaximized={true}
                    isAvailableBreadcrumbs={true}
                    isAvailableRefetch={true}
                    breadcrumbs={breadcrumbs} 
                    height={"700px"} 
                    onRefetch={async () => {
                        await refetchGetCartasNotarales();
                        cogoToast.success('Registros actualizado satisfactoriamente!', {
                            //hideAfter: 0,
                            heading: 'Listado de Cartas Notariales',
                            position: 'top-right'
                        });
                    }}>
                    <WrappedAgTable
                        {...agGridCartasNotariales} >
                    </WrappedAgTable>
                </CardEx>


                <ConfigurationGenerationCartaNotarialModal
                    showModal={showConfigurationGenerationModal}
                    setShowModal={setShowConfigurationGenerationModal}
                    title="Configuración para la generación de Cartas Notariales"
                    onConfirm={handleConfirmConfiguration}
                    isFinishSave={isFinishConfigurationSave}
                    setIsFinishSave={setIsFinishConfigurationSave}
                    messageError={configurationSaveErrorMessage}
                    onClose={handleCloseConfiguration}
                    value={configurationGenerationCnRes?.data}
                />

                <ConfirmWithLoader
                    showModal={showGenerationCartaModal}
                    setShowModal={setShowGenerationCartaModal}
                    title={"Generación de Carta Notarial"}
                    isLoading={isLoandingGenerationCarta}
                    isFinish={isFinishGenerationCarta}
                    textButton={"Generar"}
                    onConfirm={handleConfirmGeneration}
                    onClose={handleCloseGeneration}>

                    {!isLoandingGenerationCarta && isFinishGenerationCarta ? (
                        <>
                            <div>La Carta Notarial ha sido generada exitosamente.</div>
                            <WrappedAgTable
                                showButtonExport={false}
                                {...agGridCartasNotarialesGenerated} >
                            </WrappedAgTable>
                        </>

                    ) : (
                        <div>Esta seguro de Generar las Cartas Notariales?</div>
                    )}
                </ConfirmWithLoader>
                <EntregaCartaModal
                    title="Entrega de Carta de Requerimiento"
                    showModal={showEntregaCartaModal}
                    setShowModal={setShowEntregaCartaModal}
                    onConfirm={handleConfirmEntregaCarta}
                    isFinishSave={isFinishEntregaCartaSave}
                    onClose={handleCloseEntregaCarta}
                    value={valueEntregaCarta}
                    messageError={entregaCartaSaveErrorMsg}
                />
            </PermissionsGate>
        </>
    )
}